// extracted by mini-css-extract-plugin
module.exports = {"componentsButton":"styles_componentsButton__34uYE","scaleDrew":"styles_scaleDrew__c1Mgd"};